<template>
    <div class="row">
        <div class="col-lg-5 col-md-12 col-12 compare_left">
            <h2 class="mb-0 font-active">Lab Grown Vs. Natural Diamond</h2>
            <p class="mb-0" v-if="$country.is_india">
                World-renowned diamond certification institutions like IGI and GIA grade both <NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')">types of diamonds</NuxtLink> based on factors such as their cut, colour, clarity, and carat. While both diamonds are equally durable and rate 10 on the Mohs hardness scale, lab created diamonds are priced better than natural diamonds and can cost up to 90% less.
            </p>
            <p class="mb-0" v-else>
                Natural diamonds form under the earth's mantle through intense heat and pressure over billions of years. In contrast, lab diamonds are grown in advanced laboratories using cutting-edge technology as a sustainable and 100% conflict-free alternative.
                <br><br>
                World-renowned diamond certification institutions like <NuxtLink :to="localePath('/blog/igi-certificate-vs-gia-certified-diamonds')">IGI and GIA</NuxtLink> grade both these <NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')">types of diamonds</NuxtLink> based on factors such as their cut, color, clarity, and carat. While both diamonds are equally durable and rate 10 on the Mohs hardness scale, lab created diamonds are priced better than natural diamonds and can cost up to 90% less.
            </p>

            <!-- <NuxtLink :to="localePath('/')">learn more</NuxtLink> -->
        </div>
        <div class="col-lg-7 col-md-12 col-12 compare_right">
            <div class="row justify-content-center align-items-end">
                <div class="col-md-4 px-0 for_desktop">
                    <ul class="ps-0">
                        <li></li>
                        <li>Source</li>
                        <li>Chemical composition </li>
                        <!-- <li>sp3 diamond carbon bonds(%):</li> -->
                        <li>Conflict-free </li>
                        <!-- <li class="mod_height">Internal Crystal Structure </li> -->
                        <li>Hardness (Mohs) </li>
                        <li>Time taken to grow </li>
                        <li>Price </li>
                    </ul>
                </div>
                <div class="col-md-4 col-6 text-center px-0">
                    <picture>
                    <source width="127" height="127" type="image/webp" srcset="~/assets/landing/loose/natural.webp">
                    <img loading="lazy" alt="Mined Dimaond" width="127" height="127" type="image/jpeg" src="~/assets/landing/loose/natural.jpg">
                    </picture>
                    <ul class="ps-0">
                        <li><strong>Mined Diamond</strong> </li>
                        <li><span class="for_mobile">Source:</span>Exists naturally </li>
                        <li><span class="for_mobile">Chemical composition </span>Carbon </li>
                        <!-- <li><span class="for_mobile">sp3 diamond carbon bonds(%):</span>100%</li> -->
                        <li><span class="for_mobile">Conflict-free </span>No </li>
                        <!-- <li class="mod_height"><span class="for_mobile">Internal Crystal Structure </span>Face-centered Cubic </li> -->
                        <li><span class="for_mobile">Hardness (Mohs) </span>10</li>
                        <li><span class="for_mobile">Time taken to grow </span>Hundreds of years </li>
                        <li>
                            <span class="for_mobile">Price</span>
                            <span v-if="$country.is_india">₹₹₹₹</span>
                            <span v-else>$$$$</span> 
                        </li>
                    </ul>
                </div>
                <div class="col-md-4 col-6 text-center px-0">
                    <picture>
                    <source width="127" height="127" type="image/webp" srcset="~/assets/landing/loose/lab_created.webp">
                    <img loading="lazy" alt="Lab grown diamond" width="127" height="127" type="image/jpeg" src="~/assets/landing/loose/lab_created.jpg">
                    </picture>
                    <ul class="ps-0">
                        <li><strong>Lab grown diamond</strong> </li>
                        <li><span class="for_mobile">Source</span>Lab created </li>
                        <li><span class="for_mobile">Chemical composition </span>Carbon </li>
                        <!-- <li><span class="for_mobile">sp3 diamond carbon bonds(%):</span>100%</li> -->
                        <li><span class="for_mobile">Conflict-free </span>Yes</li>
                        <!-- <li class="mod_height"><span class="for_mobile">Internal Crystal Structure </span>Face-centered Cubic </li> -->
                        <li><span class="for_mobile">Hardness(Mohs) </span>10</li>
                        <li><span class="for_mobile">Time taken to grow </span>30 to 40 days </li>
                        <li>
                            <span class="for_mobile">Price</span>
                            <span v-if="$country.is_india">₹₹</span>
                            <span v-else>$$</span> 
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const localePath = useLocalePath();
const { $country } = useNuxtApp();
</script>

<style scoped>
.compare_right {
    padding-left: 7%;
}
.compare_left {
    padding-right: 7%;
}
 p a {
 
    font-size: 14px;
    color: var(--green);
    text-decoration: underline;
  
}
h2 {
    font-size: 40px;
}

p {
    font-size: 16px;
    color: #6a6161;
    padding: 5% 0;
}
ul {
    padding-top: 7%;
}
ul li {
    list-style: none;
    font-size: 16px;
    color: #564a4a;
    border-bottom: 1px solid #cacaca;
    padding: 7px 0;
    text-transform: capitalize;
}
ul li:last-child{
    border: 0;
}
@media(max-width: 1105px){
    li.mod_height {
        height: 65px;
       
    }
}
@media(max-width: 992px){
    h2{
        font-size: 32px;
    }
    li.mod_height {
        height: auto;
       
    }
    p{
        padding: 2% 0 4%;
    }
    .compare_right {
        padding: 0 4%;
    }
}
@media(max-width: 767px){
    .compare_left {
        padding: 5% 0;
    }
    h2{
        font-size: 24px;
    }
    .compare_right {
        padding: 8% 4%;
    }
    ul li{
        font-size: 14px;
    }
}
</style>
